// PieChart.jsx
import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js';
import {Pie} from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({positive, negative}) => {
  const data = {
    labels: ['Positive', 'Negative'],
    datasets: [
      {
        data: [positive, negative],
        backgroundColor: ['#28a745', '#dc3545'],
        borderColor: ['#fff', '#fff'],
        borderWidth: 2
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
          padding: 15
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        bodyFont: {size: 14},
        titleFont: {size: 16}
      }
    },
    cutout: '65%'
  };

  return <Pie data={data} options={options} />;
};

export default PieChart;
